"use client";

import { useActionState, useState } from "react";

import { Button } from "@/components/ui/button";
import { pedirEntradaComSenha, pedirLink, type EstadoPedido } from "@/lib/auth/acoes";
import { cn } from "@/lib/utils";

type Aba = "link" | "senha";

export default function FormularioLogin() {
  const [aba, setAba] = useState<Aba>("link");
  const [ultima, setUltima] = useState<Aba>("senha");
  const [estadoLink, acaoLink, enviandoLink] = useActionState<EstadoPedido | null, FormData>(pedirLink, null);
  const [estadoSenha, acaoSenha, enviandoSenha] = useActionState<EstadoPedido | null, FormData>(pedirEntradaComSenha, null);

  return (
    <div className="space-y-4">
      <div role="tablist" aria-label="Forma de entrar" className="flex gap-4 border-b border-borda text-14">
        {(
          [
            ["link", "Link por e-mail"],
            ["senha", "Senha"],
          ] as const
        ).map(([id, rotulo]) => (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={aba === id}
            onClick={() => setAba(id)}
            className={cn("-mb-px border-b-2 pb-2", aba === id ? "border-marca font-semibold text-texto" : "border-transparent text-texto-2 hover:text-marca")}
          >
            {rotulo}
          </button>
        ))}
      </div>

      {aba === "link" ? (
        <form action={acaoLink} className="space-y-4">
          <p className="text-14 text-texto-2">Sem senha: enviamos um link de acesso para o seu e-mail.</p>
          <label className="block space-y-1">
            <span className="rotulo-secao">E-mail</span>
            <input name="email" type="email" required autoComplete="email" className="campo w-full px-3 py-2 text-15" />
          </label>
          <Button type="submit" size="lg" disabled={enviandoLink}>
            {enviandoLink ? "Enviando..." : "Receber link de acesso"}
          </Button>
          <Mensagem estado={estadoLink} />
        </form>
      ) : (
        <form action={acaoSenha} className="space-y-4">
          <p className="text-14 text-texto-2">Entrada com senha para a agencia. Clientes entram pelo link por e-mail.</p>
          <label className="block space-y-1">
            <span className="rotulo-secao">E-mail</span>
            <input name="email" type="email" required autoComplete="username" className="campo w-full px-3 py-2 text-15" />
          </label>
          <label className="block space-y-1">
            <span className="rotulo-secao">Senha</span>
            <input name="senha" type="password" required maxLength={128} autoComplete="current-password" className="campo w-full px-3 py-2 text-15" />
          </label>
          <div className="flex flex-wrap items-center gap-3">
            <Button type="submit" size="lg" onClick={() => setUltima("senha")} disabled={enviandoSenha || enviandoLink}>
              {enviandoSenha ? "Entrando..." : "Entrar"}
            </Button>
            {/* "Esqueci a senha" = o pedido de link magico normal, com o e-mail digitado (mesmas regras e limite). */}
            <button type="submit" formAction={acaoLink} formNoValidate onClick={() => setUltima("link")}className="text-14 text-marca underline" disabled={enviandoSenha || enviandoLink}>
              Esqueci a senha
            </button>
          </div>
          <Mensagem estado={ultima === "link" ? estadoLink : estadoSenha} />
          {ultima === "link" && estadoLink?.linkDev && <LinkDev href={estadoLink.linkDev} />}
        </form>
      )}
      {aba === "link" && estadoLink?.linkDev && <LinkDev href={estadoLink.linkDev} />}
    </div>
  );
}

function Mensagem({ estado }: { estado: EstadoPedido | null }) {
  if (!estado) return null;
  return (
    <p role="status" className="text-14">
      {estado.mensagem}
    </p>
  );
}

function LinkDev({ href }: { href: string }) {
  return (
    <div className="rounded-item border border-dashed border-tracejado p-3 text-14">
      <p className="font-semibold">E-mail simulado (so no Dev)</p>
      <a href={href} className="break-all text-marca underline">
        Abrir link de acesso
      </a>
    </div>
  );
}
